// source: xcommon/dialer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_module_pb = require('../xcommon/module_pb.js');
goog.object.extend(proto, xcommon_module_pb);
goog.exportSymbol('proto.xcommon.AudioMarkText', null, global);
goog.exportSymbol('proto.xcommon.AudioMarkTextList', null, global);
goog.exportSymbol('proto.xcommon.AudioText', null, global);
goog.exportSymbol('proto.xcommon.BatchAudioQualityReq', null, global);
goog.exportSymbol('proto.xcommon.CallRecordReq', null, global);
goog.exportSymbol('proto.xcommon.CallRecordResp', null, global);
goog.exportSymbol('proto.xcommon.CallTextReq', null, global);
goog.exportSymbol('proto.xcommon.CallTextResp', null, global);
goog.exportSymbol('proto.xcommon.DialInfo', null, global);
goog.exportSymbol('proto.xcommon.DialInfoBackend', null, global);
goog.exportSymbol('proto.xcommon.DialInfoReq', null, global);
goog.exportSymbol('proto.xcommon.DialInfoResp', null, global);
goog.exportSymbol('proto.xcommon.DialRecord', null, global);
goog.exportSymbol('proto.xcommon.DialReq', null, global);
goog.exportSymbol('proto.xcommon.DialResp', null, global);
goog.exportSymbol('proto.xcommon.DialStatsBackend', null, global);
goog.exportSymbol('proto.xcommon.DialStatsReq', null, global);
goog.exportSymbol('proto.xcommon.DialStatsResp', null, global);
goog.exportSymbol('proto.xcommon.Dimension', null, global);
goog.exportSymbol('proto.xcommon.ExtenStatusReq', null, global);
goog.exportSymbol('proto.xcommon.ExtenStatusResp', null, global);
goog.exportSymbol('proto.xcommon.GetDialListParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetDialListParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetDialListReq', null, global);
goog.exportSymbol('proto.xcommon.GetDialListResp', null, global);
goog.exportSymbol('proto.xcommon.GetTimeRangeRobotDialStatusReq', null, global);
goog.exportSymbol('proto.xcommon.GetTimeRangeRobotDialStatusResp', null, global);
goog.exportSymbol('proto.xcommon.KillCallReq', null, global);
goog.exportSymbol('proto.xcommon.MediaObjKeyReq', null, global);
goog.exportSymbol('proto.xcommon.MediaObjKeyResp', null, global);
goog.exportSymbol('proto.xcommon.MediaReq', null, global);
goog.exportSymbol('proto.xcommon.MediaResp', null, global);
goog.exportSymbol('proto.xcommon.MediaV2Req', null, global);
goog.exportSymbol('proto.xcommon.MediaV2Resp', null, global);
goog.exportSymbol('proto.xcommon.Operate', null, global);
goog.exportSymbol('proto.xcommon.RobotCallDialog', null, global);
goog.exportSymbol('proto.xcommon.RobotCallRecord', null, global);
goog.exportSymbol('proto.xcommon.RobotCallRecordListReq', null, global);
goog.exportSymbol('proto.xcommon.RobotCallRecordListResp', null, global);
goog.exportSymbol('proto.xcommon.RobotCallRecordReq', null, global);
goog.exportSymbol('proto.xcommon.RobotCallRecordResp', null, global);
goog.exportSymbol('proto.xcommon.SaveCallTextReq', null, global);
goog.exportSymbol('proto.xcommon.SaveCallTextResp', null, global);
goog.exportSymbol('proto.xcommon.StatusReq', null, global);
goog.exportSymbol('proto.xcommon.StatusResp', null, global);
goog.exportSymbol('proto.xcommon.UnassignReq', null, global);
goog.exportSymbol('proto.xcommon.UserDialInfoReq', null, global);
goog.exportSymbol('proto.xcommon.UserDialInfoResp', null, global);
goog.exportSymbol('proto.xcommon.WhetherRobotCallListResp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialRecord.displayName = 'proto.xcommon.DialRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UnassignReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.UnassignReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.UnassignReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UnassignReq.displayName = 'proto.xcommon.UnassignReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialReq.displayName = 'proto.xcommon.DialReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialResp.displayName = 'proto.xcommon.DialResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialInfoReq.displayName = 'proto.xcommon.DialInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialInfoResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.DialInfoResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.DialInfoResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialInfoResp.displayName = 'proto.xcommon.DialInfoResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialInfo.displayName = 'proto.xcommon.DialInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.KillCallReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.KillCallReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.KillCallReq.displayName = 'proto.xcommon.KillCallReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ExtenStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ExtenStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ExtenStatusReq.displayName = 'proto.xcommon.ExtenStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ExtenStatusResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ExtenStatusResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ExtenStatusResp.displayName = 'proto.xcommon.ExtenStatusResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.StatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.StatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.StatusReq.displayName = 'proto.xcommon.StatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.StatusResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.StatusResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.StatusResp.displayName = 'proto.xcommon.StatusResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserDialInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserDialInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserDialInfoReq.displayName = 'proto.xcommon.UserDialInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserDialInfoResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserDialInfoResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserDialInfoResp.displayName = 'proto.xcommon.UserDialInfoResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialListParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetDialListParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialListParamReq.displayName = 'proto.xcommon.GetDialListParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialListParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetDialListParamResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetDialListParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialListParamResp.displayName = 'proto.xcommon.GetDialListParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetDialListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialListReq.displayName = 'proto.xcommon.GetDialListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetDialListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetDialListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialListResp.displayName = 'proto.xcommon.GetDialListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialInfoBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialInfoBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialInfoBackend.displayName = 'proto.xcommon.DialInfoBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MediaReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MediaReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MediaReq.displayName = 'proto.xcommon.MediaReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MediaResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MediaResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MediaResp.displayName = 'proto.xcommon.MediaResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MediaV2Req = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MediaV2Req, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MediaV2Req.displayName = 'proto.xcommon.MediaV2Req';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MediaV2Resp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MediaV2Resp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MediaV2Resp.displayName = 'proto.xcommon.MediaV2Resp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MediaObjKeyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MediaObjKeyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MediaObjKeyReq.displayName = 'proto.xcommon.MediaObjKeyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MediaObjKeyResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MediaObjKeyResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MediaObjKeyResp.displayName = 'proto.xcommon.MediaObjKeyResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.DialStatsReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.DialStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialStatsReq.displayName = 'proto.xcommon.DialStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.DialStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.DialStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialStatsResp.displayName = 'proto.xcommon.DialStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialStatsBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialStatsBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialStatsBackend.displayName = 'proto.xcommon.DialStatsBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CallRecordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CallRecordReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CallRecordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CallRecordReq.displayName = 'proto.xcommon.CallRecordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CallRecordResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CallRecordResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CallRecordResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CallRecordResp.displayName = 'proto.xcommon.CallRecordResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CallTextReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CallTextReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CallTextReq.displayName = 'proto.xcommon.CallTextReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CallTextResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CallTextResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CallTextResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CallTextResp.displayName = 'proto.xcommon.CallTextResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AudioText = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AudioText.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AudioText, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AudioText.displayName = 'proto.xcommon.AudioText';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AudioMarkTextList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AudioMarkTextList.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AudioMarkTextList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AudioMarkTextList.displayName = 'proto.xcommon.AudioMarkTextList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AudioMarkText = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AudioMarkText, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AudioMarkText.displayName = 'proto.xcommon.AudioMarkText';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveCallTextReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SaveCallTextReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SaveCallTextReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveCallTextReq.displayName = 'proto.xcommon.SaveCallTextReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveCallTextResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveCallTextResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveCallTextResp.displayName = 'proto.xcommon.SaveCallTextResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchAudioQualityReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchAudioQualityReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchAudioQualityReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchAudioQualityReq.displayName = 'proto.xcommon.BatchAudioQualityReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallRecordListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RobotCallRecordListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallRecordListReq.displayName = 'proto.xcommon.RobotCallRecordListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallRecordListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.RobotCallRecordListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.RobotCallRecordListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallRecordListResp.displayName = 'proto.xcommon.RobotCallRecordListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallRecordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RobotCallRecordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallRecordReq.displayName = 'proto.xcommon.RobotCallRecordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallRecordResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RobotCallRecordResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallRecordResp.displayName = 'proto.xcommon.RobotCallRecordResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.RobotCallRecord.repeatedFields_, null);
};
goog.inherits(proto.xcommon.RobotCallRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallRecord.displayName = 'proto.xcommon.RobotCallRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallDialog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RobotCallDialog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallDialog.displayName = 'proto.xcommon.RobotCallDialog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WhetherRobotCallListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WhetherRobotCallListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WhetherRobotCallListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WhetherRobotCallListResp.displayName = 'proto.xcommon.WhetherRobotCallListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTimeRangeRobotDialStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTimeRangeRobotDialStatusReq.displayName = 'proto.xcommon.GetTimeRangeRobotDialStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTimeRangeRobotDialStatusResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTimeRangeRobotDialStatusResp.displayName = 'proto.xcommon.GetTimeRangeRobotDialStatusResp';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    startedat: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endat: jspb.Message.getFieldWithDefault(msg, 2, 0),
    duration: jspb.Message.getFieldWithDefault(msg, 3, 0),
    mobile: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialRecord}
 */
proto.xcommon.DialRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialRecord;
  return proto.xcommon.DialRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialRecord}
 */
proto.xcommon.DialRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndat(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartedat();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndat();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 StartedAt = 1;
 * @return {number}
 */
proto.xcommon.DialRecord.prototype.getStartedat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialRecord} returns this
 */
proto.xcommon.DialRecord.prototype.setStartedat = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 EndAt = 2;
 * @return {number}
 */
proto.xcommon.DialRecord.prototype.getEndat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialRecord} returns this
 */
proto.xcommon.DialRecord.prototype.setEndat = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Duration = 3;
 * @return {number}
 */
proto.xcommon.DialRecord.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialRecord} returns this
 */
proto.xcommon.DialRecord.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Mobile = 4;
 * @return {string}
 */
proto.xcommon.DialRecord.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialRecord} returns this
 */
proto.xcommon.DialRecord.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.UnassignReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UnassignReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UnassignReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UnassignReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UnassignReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    idsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    opuid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UnassignReq}
 */
proto.xcommon.UnassignReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UnassignReq;
  return proto.xcommon.UnassignReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UnassignReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UnassignReq}
 */
proto.xcommon.UnassignReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIds(values[i]);
      }
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UnassignReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UnassignReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UnassignReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UnassignReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.UnassignReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.UnassignReq} returns this
*/
proto.xcommon.UnassignReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UnassignReq} returns this
 */
proto.xcommon.UnassignReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UnassignReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 IDs = 2;
 * @return {!Array<number>}
 */
proto.xcommon.UnassignReq.prototype.getIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.xcommon.UnassignReq} returns this
 */
proto.xcommon.UnassignReq.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UnassignReq} returns this
 */
proto.xcommon.UnassignReq.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.UnassignReq} returns this
 */
proto.xcommon.UnassignReq.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * optional int64 OpUid = 3;
 * @return {number}
 */
proto.xcommon.UnassignReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UnassignReq} returns this
 */
proto.xcommon.UnassignReq.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    assignid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    tickettype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    dialway: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialReq}
 */
proto.xcommon.DialReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialReq;
  return proto.xcommon.DialReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialReq}
 */
proto.xcommon.DialReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTickettype(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDialway(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getTickettype();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getDialway();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DialReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.DialReq} returns this
*/
proto.xcommon.DialReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 AssignId = 2;
 * @return {number}
 */
proto.xcommon.DialReq.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string PhoneNumber = 3;
 * @return {string}
 */
proto.xcommon.DialReq.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 Supplier = 4;
 * @return {number}
 */
proto.xcommon.DialReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.DialReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional int32 TicketType = 6;
 * @return {number}
 */
proto.xcommon.DialReq.prototype.getTickettype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.setTickettype = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 TicketId = 7;
 * @return {number}
 */
proto.xcommon.DialReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 OpUid = 8;
 * @return {number}
 */
proto.xcommon.DialReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 DialWay = 9;
 * @return {number}
 */
proto.xcommon.DialReq.prototype.getDialway = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialReq} returns this
 */
proto.xcommon.DialReq.prototype.setDialway = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    dialid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialResp}
 */
proto.xcommon.DialResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialResp;
  return proto.xcommon.DialResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialResp}
 */
proto.xcommon.DialResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setDialid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDialid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DialResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.DialResp} returns this
*/
proto.xcommon.DialResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialResp} returns this
 */
proto.xcommon.DialResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 DialId = 2;
 * @return {string}
 */
proto.xcommon.DialResp.prototype.getDialid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialResp} returns this
 */
proto.xcommon.DialResp.prototype.setDialid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    dialid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    robotcall: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialInfoReq}
 */
proto.xcommon.DialInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialInfoReq;
  return proto.xcommon.DialInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialInfoReq}
 */
proto.xcommon.DialInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setDialid(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setRobotcall(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getDialid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getRobotcall();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DialInfoReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.DialInfoReq} returns this
*/
proto.xcommon.DialInfoReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialInfoReq} returns this
 */
proto.xcommon.DialInfoReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialInfoReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 DialId = 2;
 * @return {string}
 */
proto.xcommon.DialInfoReq.prototype.getDialid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoReq} returns this
 */
proto.xcommon.DialInfoReq.prototype.setDialid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional Bool RobotCall = 3;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.DialInfoReq.prototype.getRobotcall = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.DialInfoReq} returns this
 */
proto.xcommon.DialInfoReq.prototype.setRobotcall = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.DialInfoResp.repeatedFields_ = [28];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialInfoResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialInfoResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialInfoResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialInfoResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    itemid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    assignid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assignuser: jspb.Message.getFieldWithDefault(msg, 7, ""),
    extnumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
    suppliertype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    supplier: jspb.Message.getFieldWithDefault(msg, 10, ""),
    disnumber: jspb.Message.getFieldWithDefault(msg, 11, ""),
    destnumber: jspb.Message.getFieldWithDefault(msg, 12, ""),
    calldirection: jspb.Message.getFieldWithDefault(msg, 13, ""),
    callmethod: jspb.Message.getFieldWithDefault(msg, 14, ""),
    starttimestamp: jspb.Message.getFieldWithDefault(msg, 15, 0),
    answertimestamp: jspb.Message.getFieldWithDefault(msg, 16, 0),
    endtimestamp: jspb.Message.getFieldWithDefault(msg, 17, 0),
    isdial: jspb.Message.getFieldWithDefault(msg, 18, ""),
    billsec: jspb.Message.getFieldWithDefault(msg, 19, 0),
    duration: jspb.Message.getFieldWithDefault(msg, 20, 0),
    hangupdirection: jspb.Message.getFieldWithDefault(msg, 21, ""),
    hangupcause: jspb.Message.getFieldWithDefault(msg, 22, ""),
    audiorecordname: jspb.Message.getFieldWithDefault(msg, 23, ""),
    audiorecordurl: jspb.Message.getFieldWithDefault(msg, 24, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 25, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 26, 0),
    dialway: jspb.Message.getFieldWithDefault(msg, 27, 0),
    dialogoriginalList: jspb.Message.toObjectList(msg.getDialogoriginalList(),
    xcommon_common_pb.RobotDialog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialInfoResp}
 */
proto.xcommon.DialInfoResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialInfoResp;
  return proto.xcommon.DialInfoResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialInfoResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialInfoResp}
 */
proto.xcommon.DialInfoResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignuser(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtnumber(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuppliertype(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplier(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisnumber(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestnumber(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalldirection(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallmethod(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarttimestamp(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswertimestamp(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtimestamp(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsdial(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBillsec(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupdirection(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupcause(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiorecordname(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiorecordurl(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDialway(value);
      break;
    case 28:
      var value = new xcommon_common_pb.RobotDialog;
      reader.readMessage(value,xcommon_common_pb.RobotDialog.deserializeBinaryFromReader);
      msg.addDialogoriginal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialInfoResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialInfoResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialInfoResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialInfoResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAssignuser();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getExtnumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSuppliertype();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getSupplier();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDisnumber();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDestnumber();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCalldirection();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCallmethod();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getStarttimestamp();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getAnswertimestamp();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getEndtimestamp();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getIsdial();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getBillsec();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getHangupdirection();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getHangupcause();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getAudiorecordname();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getAudiorecordurl();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getDialway();
  if (f !== 0) {
    writer.writeInt32(
      27,
      f
    );
  }
  f = message.getDialogoriginalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      28,
      f,
      xcommon_common_pb.RobotDialog.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DialInfoResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.DialInfoResp} returns this
*/
proto.xcommon.DialInfoResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialInfoResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 ID = 2;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 OrderID = 3;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 ItemID = 4;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 TicketID = 5;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AssignID = 6;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string AssignUser = 7;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getAssignuser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setAssignuser = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string ExtNumber = 8;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getExtnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 SupplierType = 9;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getSuppliertype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setSuppliertype = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string Supplier = 10;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getSupplier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string DisNumber = 11;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getDisnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setDisnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string DestNumber = 12;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getDestnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setDestnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string CallDirection = 13;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getCalldirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setCalldirection = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string CallMethod = 14;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getCallmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setCallmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int64 StartTimestamp = 15;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getStarttimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setStarttimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 AnswerTimestamp = 16;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getAnswertimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setAnswertimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 EndTimestamp = 17;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getEndtimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setEndtimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string IsDial = 18;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getIsdial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setIsdial = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int64 BillSec = 19;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getBillsec = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setBillsec = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 Duration = 20;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string HangupDirection = 21;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getHangupdirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setHangupdirection = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string HangupCause = 22;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getHangupcause = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setHangupcause = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string AudioRecordName = 23;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getAudiorecordname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setAudiorecordname = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string AudioRecordURL = 24;
 * @return {string}
 */
proto.xcommon.DialInfoResp.prototype.getAudiorecordurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setAudiorecordurl = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional int64 Ctime = 25;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 Utime = 26;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int32 DialWay = 27;
 * @return {number}
 */
proto.xcommon.DialInfoResp.prototype.getDialway = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.setDialway = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * repeated RobotDialog DialogOriginal = 28;
 * @return {!Array<!proto.xcommon.RobotDialog>}
 */
proto.xcommon.DialInfoResp.prototype.getDialogoriginalList = function() {
  return /** @type{!Array<!proto.xcommon.RobotDialog>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_common_pb.RobotDialog, 28));
};


/**
 * @param {!Array<!proto.xcommon.RobotDialog>} value
 * @return {!proto.xcommon.DialInfoResp} returns this
*/
proto.xcommon.DialInfoResp.prototype.setDialogoriginalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 28, value);
};


/**
 * @param {!proto.xcommon.RobotDialog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RobotDialog}
 */
proto.xcommon.DialInfoResp.prototype.addDialogoriginal = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 28, opt_value, proto.xcommon.RobotDialog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.DialInfoResp} returns this
 */
proto.xcommon.DialInfoResp.prototype.clearDialogoriginalList = function() {
  return this.setDialogoriginalList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ticketid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    callid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    omgroupid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    tlgroupid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 9, 0),
    assignid: jspb.Message.getFieldWithDefault(msg, 10, 0),
    assignuname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    extnumber: jspb.Message.getFieldWithDefault(msg, 12, 0),
    suppliertype: jspb.Message.getFieldWithDefault(msg, 13, 0),
    disnumber: jspb.Message.getFieldWithDefault(msg, 14, ""),
    destnumber: jspb.Message.getFieldWithDefault(msg, 15, ""),
    calldirection: jspb.Message.getFieldWithDefault(msg, 16, 0),
    callmethod: jspb.Message.getFieldWithDefault(msg, 17, 0),
    starttime: jspb.Message.getFieldWithDefault(msg, 18, ""),
    answertime: jspb.Message.getFieldWithDefault(msg, 19, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 20, ""),
    starttimestamp: jspb.Message.getFieldWithDefault(msg, 21, 0),
    answertimestamp: jspb.Message.getFieldWithDefault(msg, 22, 0),
    endtimestamp: jspb.Message.getFieldWithDefault(msg, 23, 0),
    isdial: jspb.Message.getFieldWithDefault(msg, 24, 0),
    billsec: jspb.Message.getFieldWithDefault(msg, 25, 0),
    duration: jspb.Message.getFieldWithDefault(msg, 26, 0),
    fee: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
    hangupdirection: jspb.Message.getFieldWithDefault(msg, 28, 0),
    hangupcause: jspb.Message.getFieldWithDefault(msg, 29, 0),
    audiorecordname: jspb.Message.getFieldWithDefault(msg, 30, ""),
    audiorecordurl: jspb.Message.getFieldWithDefault(msg, 31, ""),
    opuid: jspb.Message.getFieldWithDefault(msg, 32, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 33, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 34, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialInfo}
 */
proto.xcommon.DialInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialInfo;
  return proto.xcommon.DialInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialInfo}
 */
proto.xcommon.DialInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOmgroupid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTlgroupid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignuname(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtnumber(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuppliertype(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisnumber(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestnumber(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCalldirection(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCallmethod(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttime(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswertime(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarttimestamp(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswertimestamp(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtimestamp(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsdial(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBillsec(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFee(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHangupdirection(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHangupcause(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiorecordname(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiorecordurl(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCallid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getOmgroupid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTlgroupid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAssignuname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getExtnumber();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getSuppliertype();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getDisnumber();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getDestnumber();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCalldirection();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getCallmethod();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAnswertime();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getStarttimestamp();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getAnswertimestamp();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getEndtimestamp();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getIsdial();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getBillsec();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getFee();
  if (f !== 0.0) {
    writer.writeFloat(
      27,
      f
    );
  }
  f = message.getHangupdirection();
  if (f !== 0) {
    writer.writeInt32(
      28,
      f
    );
  }
  f = message.getHangupcause();
  if (f !== 0) {
    writer.writeInt32(
      29,
      f
    );
  }
  f = message.getAudiorecordname();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getAudiorecordurl();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      32,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      33,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      34,
      f
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 OrderID = 2;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 ItemID = 3;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Sid = 4;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setSid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 TicketID = 5;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 CallID = 6;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getCallid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setCallid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 OmGroupID = 7;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getOmgroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setOmgroupid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 TLGroupID = 8;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getTlgroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setTlgroupid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 UserGroupID = 9;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setUsergroupid = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 AssignID = 10;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string AssignUName = 11;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getAssignuname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setAssignuname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 ExtNumber = 12;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getExtnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 SupplierType = 13;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getSuppliertype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setSuppliertype = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string DisNumber = 14;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getDisnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setDisnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string DestNumber = 15;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getDestnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setDestnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 CallDirection = 16;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getCalldirection = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setCalldirection = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 CallMethod = 17;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getCallmethod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setCallmethod = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string StartTime = 18;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getStarttime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setStarttime = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string AnswerTime = 19;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getAnswertime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setAnswertime = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string EndTime = 20;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional int64 StartTimestamp = 21;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getStarttimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setStarttimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 AnswerTimestamp = 22;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getAnswertimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setAnswertimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 EndTimestamp = 23;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getEndtimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setEndtimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int32 IsDial = 24;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getIsdial = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setIsdial = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 BillSec = 25;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getBillsec = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setBillsec = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 Duration = 26;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional float Fee = 27;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getFee = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setFee = function(value) {
  return jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional int32 HangupDirection = 28;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getHangupdirection = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setHangupdirection = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * optional int32 HangupCause = 29;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getHangupcause = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setHangupcause = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional string AudioRecordName = 30;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getAudiorecordname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setAudiorecordname = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string AudioRecordURL = 31;
 * @return {string}
 */
proto.xcommon.DialInfo.prototype.getAudiorecordurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setAudiorecordurl = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional int64 OpUID = 32;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional int64 Ctime = 33;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional int64 Utime = 34;
 * @return {number}
 */
proto.xcommon.DialInfo.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialInfo} returns this
 */
proto.xcommon.DialInfo.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.KillCallReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.KillCallReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.KillCallReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.KillCallReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    assignid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    supplier: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.KillCallReq}
 */
proto.xcommon.KillCallReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.KillCallReq;
  return proto.xcommon.KillCallReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.KillCallReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.KillCallReq}
 */
proto.xcommon.KillCallReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.KillCallReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.KillCallReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.KillCallReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.KillCallReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.KillCallReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.KillCallReq} returns this
*/
proto.xcommon.KillCallReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.KillCallReq} returns this
 */
proto.xcommon.KillCallReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.KillCallReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 AssignId = 2;
 * @return {number}
 */
proto.xcommon.KillCallReq.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.KillCallReq} returns this
 */
proto.xcommon.KillCallReq.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Supplier = 3;
 * @return {number}
 */
proto.xcommon.KillCallReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.KillCallReq} returns this
 */
proto.xcommon.KillCallReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ExtenStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ExtenStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ExtenStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtenStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    assignid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    supplier: jspb.Message.getFieldWithDefault(msg, 3, 0),
    exten: jspb.Message.getFieldWithDefault(msg, 4, ""),
    domain: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ExtenStatusReq}
 */
proto.xcommon.ExtenStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ExtenStatusReq;
  return proto.xcommon.ExtenStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ExtenStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ExtenStatusReq}
 */
proto.xcommon.ExtenStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExten(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ExtenStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ExtenStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ExtenStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtenStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAssignid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getExten();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ExtenStatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.ExtenStatusReq} returns this
*/
proto.xcommon.ExtenStatusReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ExtenStatusReq} returns this
 */
proto.xcommon.ExtenStatusReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ExtenStatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 AssignId = 2;
 * @return {number}
 */
proto.xcommon.ExtenStatusReq.prototype.getAssignid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenStatusReq} returns this
 */
proto.xcommon.ExtenStatusReq.prototype.setAssignid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Supplier = 3;
 * @return {number}
 */
proto.xcommon.ExtenStatusReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtenStatusReq} returns this
 */
proto.xcommon.ExtenStatusReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Exten = 4;
 * @return {string}
 */
proto.xcommon.ExtenStatusReq.prototype.getExten = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtenStatusReq} returns this
 */
proto.xcommon.ExtenStatusReq.prototype.setExten = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Domain = 5;
 * @return {string}
 */
proto.xcommon.ExtenStatusReq.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtenStatusReq} returns this
 */
proto.xcommon.ExtenStatusReq.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ExtenStatusResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ExtenStatusResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ExtenStatusResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtenStatusResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    sid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ExtenStatusResp}
 */
proto.xcommon.ExtenStatusResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ExtenStatusResp;
  return proto.xcommon.ExtenStatusResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ExtenStatusResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ExtenStatusResp}
 */
proto.xcommon.ExtenStatusResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ExtenStatusResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ExtenStatusResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ExtenStatusResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtenStatusResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ExtenStatusResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.ExtenStatusResp} returns this
*/
proto.xcommon.ExtenStatusResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ExtenStatusResp} returns this
 */
proto.xcommon.ExtenStatusResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ExtenStatusResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Sid = 2;
 * @return {string}
 */
proto.xcommon.ExtenStatusResp.prototype.getSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtenStatusResp} returns this
 */
proto.xcommon.ExtenStatusResp.prototype.setSid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.StatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.StatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.StatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.StatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    sid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.StatusReq}
 */
proto.xcommon.StatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.StatusReq;
  return proto.xcommon.StatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.StatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.StatusReq}
 */
proto.xcommon.StatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.StatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.StatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.StatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.StatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getSid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.StatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.StatusReq} returns this
*/
proto.xcommon.StatusReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.StatusReq} returns this
 */
proto.xcommon.StatusReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.StatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Sid = 2;
 * @return {string}
 */
proto.xcommon.StatusReq.prototype.getSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.StatusReq} returns this
 */
proto.xcommon.StatusReq.prototype.setSid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.StatusResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.StatusResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.StatusResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.StatusResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    sid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    exten: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currentstatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    currentstatusdesc: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isdial: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    callstarttime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    callworkerringtime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    callworkeruptime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    callworkerendtime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    callworkerhangupreason: jspb.Message.getFieldWithDefault(msg, 12, ""),
    callcustomerringtime: jspb.Message.getFieldWithDefault(msg, 13, 0),
    callcustomeruptime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    callcustomerendtime: jspb.Message.getFieldWithDefault(msg, 15, 0),
    callcustomerhangupreason: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.StatusResp}
 */
proto.xcommon.StatusResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.StatusResp;
  return proto.xcommon.StatusResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.StatusResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.StatusResp}
 */
proto.xcommon.StatusResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExten(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentstatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentstatusdesc(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsdial(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallstarttime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallworkerringtime(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallworkeruptime(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallworkerendtime(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallworkerhangupreason(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallcustomerringtime(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallcustomeruptime(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallcustomerendtime(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallcustomerhangupreason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.StatusResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.StatusResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.StatusResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.StatusResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExten();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrentstatus();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCurrentstatusdesc();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsdial();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCallstarttime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCallworkerringtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getCallworkeruptime();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCallworkerendtime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getCallworkerhangupreason();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCallcustomerringtime();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getCallcustomeruptime();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getCallcustomerendtime();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getCallcustomerhangupreason();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.StatusResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.StatusResp} returns this
*/
proto.xcommon.StatusResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.StatusResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Sid = 2;
 * @return {string}
 */
proto.xcommon.StatusResp.prototype.getSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setSid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Exten = 3;
 * @return {string}
 */
proto.xcommon.StatusResp.prototype.getExten = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setExten = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PhoneNumber = 4;
 * @return {string}
 */
proto.xcommon.StatusResp.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 CurrentStatus = 5;
 * @return {number}
 */
proto.xcommon.StatusResp.prototype.getCurrentstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCurrentstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string CurrentStatusDesc = 6;
 * @return {string}
 */
proto.xcommon.StatusResp.prototype.getCurrentstatusdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCurrentstatusdesc = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool IsDial = 7;
 * @return {boolean}
 */
proto.xcommon.StatusResp.prototype.getIsdial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setIsdial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional int64 CallStartTime = 8;
 * @return {number}
 */
proto.xcommon.StatusResp.prototype.getCallstarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallstarttime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 CallWorkerRingTime = 9;
 * @return {number}
 */
proto.xcommon.StatusResp.prototype.getCallworkerringtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallworkerringtime = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 CallWorkerUpTime = 10;
 * @return {number}
 */
proto.xcommon.StatusResp.prototype.getCallworkeruptime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallworkeruptime = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 CallWorkerEndTime = 11;
 * @return {number}
 */
proto.xcommon.StatusResp.prototype.getCallworkerendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallworkerendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string CallWorkerHangupReason = 12;
 * @return {string}
 */
proto.xcommon.StatusResp.prototype.getCallworkerhangupreason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallworkerhangupreason = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 CallCustomerRingTime = 13;
 * @return {number}
 */
proto.xcommon.StatusResp.prototype.getCallcustomerringtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallcustomerringtime = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 CallCustomerUpTime = 14;
 * @return {number}
 */
proto.xcommon.StatusResp.prototype.getCallcustomeruptime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallcustomeruptime = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 CallCustomerEndTime = 15;
 * @return {number}
 */
proto.xcommon.StatusResp.prototype.getCallcustomerendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallcustomerendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string CallCustomerHangupReason = 16;
 * @return {string}
 */
proto.xcommon.StatusResp.prototype.getCallcustomerhangupreason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.StatusResp} returns this
 */
proto.xcommon.StatusResp.prototype.setCallcustomerhangupreason = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserDialInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserDialInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserDialInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserDialInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    starttime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserDialInfoReq}
 */
proto.xcommon.UserDialInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserDialInfoReq;
  return proto.xcommon.UserDialInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserDialInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserDialInfoReq}
 */
proto.xcommon.UserDialInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarttime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserDialInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserDialInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserDialInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserDialInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getStarttime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.UserDialInfoReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.UserDialInfoReq} returns this
*/
proto.xcommon.UserDialInfoReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UserDialInfoReq} returns this
 */
proto.xcommon.UserDialInfoReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UserDialInfoReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 ItemID = 2;
 * @return {number}
 */
proto.xcommon.UserDialInfoReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserDialInfoReq} returns this
 */
proto.xcommon.UserDialInfoReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AdminUID = 3;
 * @return {number}
 */
proto.xcommon.UserDialInfoReq.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserDialInfoReq} returns this
 */
proto.xcommon.UserDialInfoReq.prototype.setAdminuid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 StartTime = 4;
 * @return {number}
 */
proto.xcommon.UserDialInfoReq.prototype.getStarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserDialInfoReq} returns this
 */
proto.xcommon.UserDialInfoReq.prototype.setStarttime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 EndTime = 5;
 * @return {number}
 */
proto.xcommon.UserDialInfoReq.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserDialInfoReq} returns this
 */
proto.xcommon.UserDialInfoReq.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserDialInfoResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserDialInfoResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserDialInfoResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserDialInfoResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    dialnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    answernum: jspb.Message.getFieldWithDefault(msg, 3, 0),
    callduration: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserDialInfoResp}
 */
proto.xcommon.UserDialInfoResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserDialInfoResp;
  return proto.xcommon.UserDialInfoResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserDialInfoResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserDialInfoResp}
 */
proto.xcommon.UserDialInfoResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDialnum(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswernum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallduration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserDialInfoResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserDialInfoResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserDialInfoResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserDialInfoResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDialnum();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAnswernum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCallduration();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.UserDialInfoResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.UserDialInfoResp} returns this
*/
proto.xcommon.UserDialInfoResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UserDialInfoResp} returns this
 */
proto.xcommon.UserDialInfoResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UserDialInfoResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 DialNum = 2;
 * @return {number}
 */
proto.xcommon.UserDialInfoResp.prototype.getDialnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserDialInfoResp} returns this
 */
proto.xcommon.UserDialInfoResp.prototype.setDialnum = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AnswerNum = 3;
 * @return {number}
 */
proto.xcommon.UserDialInfoResp.prototype.getAnswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserDialInfoResp} returns this
 */
proto.xcommon.UserDialInfoResp.prototype.setAnswernum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 CallDuration = 4;
 * @return {number}
 */
proto.xcommon.UserDialInfoResp.prototype.getCallduration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UserDialInfoResp} returns this
 */
proto.xcommon.UserDialInfoResp.prototype.setCallduration = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialListParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialListParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialListParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialListParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialListParamReq}
 */
proto.xcommon.GetDialListParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialListParamReq;
  return proto.xcommon.GetDialListParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialListParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialListParamReq}
 */
proto.xcommon.GetDialListParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialListParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialListParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialListParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialListParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetDialListParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetDialListParamReq} returns this
*/
proto.xcommon.GetDialListParamReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetDialListParamReq} returns this
 */
proto.xcommon.GetDialListParamReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialListParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetDialListParamResp.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialListParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialListParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialListParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialListParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    ticketitemList: jspb.Message.toObjectList(msg.getTicketitemList(),
    xcommon_module_pb.Meta.toObject, includeInstance),
    roleidsList: jspb.Message.toObjectList(msg.getRoleidsList(),
    xcommon_module_pb.Meta.toObject, includeInstance),
    supplierMap: (f = msg.getSupplierMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialListParamResp}
 */
proto.xcommon.GetDialListParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialListParamResp;
  return proto.xcommon.GetDialListParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialListParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialListParamResp}
 */
proto.xcommon.GetDialListParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.addTicketitem(value);
      break;
    case 3:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.addRoleids(value);
      break;
    case 4:
      var value = msg.getSupplierMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialListParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialListParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialListParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialListParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTicketitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
  f = message.getRoleidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
  f = message.getSupplierMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetDialListParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetDialListParamResp} returns this
*/
proto.xcommon.GetDialListParamResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetDialListParamResp} returns this
 */
proto.xcommon.GetDialListParamResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialListParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Meta TicketItem = 2;
 * @return {!Array<!proto.xcommon.Meta>}
 */
proto.xcommon.GetDialListParamResp.prototype.getTicketitemList = function() {
  return /** @type{!Array<!proto.xcommon.Meta>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_module_pb.Meta, 2));
};


/**
 * @param {!Array<!proto.xcommon.Meta>} value
 * @return {!proto.xcommon.GetDialListParamResp} returns this
*/
proto.xcommon.GetDialListParamResp.prototype.setTicketitemList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.Meta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Meta}
 */
proto.xcommon.GetDialListParamResp.prototype.addTicketitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.Meta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetDialListParamResp} returns this
 */
proto.xcommon.GetDialListParamResp.prototype.clearTicketitemList = function() {
  return this.setTicketitemList([]);
};


/**
 * repeated Meta RoleIDs = 3;
 * @return {!Array<!proto.xcommon.Meta>}
 */
proto.xcommon.GetDialListParamResp.prototype.getRoleidsList = function() {
  return /** @type{!Array<!proto.xcommon.Meta>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_module_pb.Meta, 3));
};


/**
 * @param {!Array<!proto.xcommon.Meta>} value
 * @return {!proto.xcommon.GetDialListParamResp} returns this
*/
proto.xcommon.GetDialListParamResp.prototype.setRoleidsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.Meta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Meta}
 */
proto.xcommon.GetDialListParamResp.prototype.addRoleids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.Meta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetDialListParamResp} returns this
 */
proto.xcommon.GetDialListParamResp.prototype.clearRoleidsList = function() {
  return this.setRoleidsList([]);
};


/**
 * map<int32, string> Supplier = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetDialListParamResp.prototype.getSupplierMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetDialListParamResp} returns this
 */
proto.xcommon.GetDialListParamResp.prototype.clearSupplierMap = function() {
  this.getSupplierMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    dialid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    assignuser: jspb.Message.getFieldWithDefault(msg, 5, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    extnumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    disnumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
    destnumber: jspb.Message.getFieldWithDefault(msg, 9, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 10, 0),
    starttimerange: jspb.Message.getFieldWithDefault(msg, 11, ""),
    createtimerange: jspb.Message.getFieldWithDefault(msg, 12, ""),
    roleids: jspb.Message.getFieldWithDefault(msg, 13, ""),
    sid: jspb.Message.getFieldWithDefault(msg, 14, ""),
    isdial: jspb.Message.getFieldWithDefault(msg, 15, 0),
    calldurationrange: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialListReq}
 */
proto.xcommon.GetDialListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialListReq;
  return proto.xcommon.GetDialListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialListReq}
 */
proto.xcommon.GetDialListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setDialid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignuser(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtnumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisnumber(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestnumber(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupplier(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttimerange(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoleids(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSid(value);
      break;
    case 15:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsdial(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalldurationrange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getDialid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getAssignuser();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExtnumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDisnumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDestnumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getStarttimerange();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRoleids();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSid();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIsdial();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getCalldurationrange();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetDialListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetDialListReq} returns this
*/
proto.xcommon.GetDialListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetDialListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetDialListReq} returns this
*/
proto.xcommon.GetDialListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 DialId = 3;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getDialid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setDialid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 OrderID = 4;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string AssignUser = 5;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getAssignuser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setAssignuser = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 ItemID = 6;
 * @return {number}
 */
proto.xcommon.GetDialListReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string ExtNumber = 7;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getExtnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string DisNumber = 8;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getDisnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setDisnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string DestNumber = 9;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getDestnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setDestnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 Supplier = 10;
 * @return {number}
 */
proto.xcommon.GetDialListReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string StartTimeRange = 11;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getStarttimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setStarttimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string CreateTimeRange = 12;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setCreatetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string RoleIDs = 13;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getRoleids = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setRoleids = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string Sid = 14;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setSid = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional Bool IsDial = 15;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetDialListReq.prototype.getIsdial = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setIsdial = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string CallDurationRange = 16;
 * @return {string}
 */
proto.xcommon.GetDialListReq.prototype.getCalldurationrange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetDialListReq} returns this
 */
proto.xcommon.GetDialListReq.prototype.setCalldurationrange = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetDialListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    dialinfosList: jspb.Message.toObjectList(msg.getDialinfosList(),
    proto.xcommon.DialInfoBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialListResp}
 */
proto.xcommon.GetDialListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialListResp;
  return proto.xcommon.GetDialListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialListResp}
 */
proto.xcommon.GetDialListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.DialInfoBackend;
      reader.readMessage(value,proto.xcommon.DialInfoBackend.deserializeBinaryFromReader);
      msg.addDialinfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getDialinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.DialInfoBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetDialListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetDialListResp} returns this
*/
proto.xcommon.GetDialListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetDialListResp} returns this
 */
proto.xcommon.GetDialListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetDialListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetDialListResp} returns this
*/
proto.xcommon.GetDialListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetDialListResp} returns this
 */
proto.xcommon.GetDialListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated DialInfoBackend DialInfos = 3;
 * @return {!Array<!proto.xcommon.DialInfoBackend>}
 */
proto.xcommon.GetDialListResp.prototype.getDialinfosList = function() {
  return /** @type{!Array<!proto.xcommon.DialInfoBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DialInfoBackend, 3));
};


/**
 * @param {!Array<!proto.xcommon.DialInfoBackend>} value
 * @return {!proto.xcommon.GetDialListResp} returns this
*/
proto.xcommon.GetDialListResp.prototype.setDialinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.DialInfoBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DialInfoBackend}
 */
proto.xcommon.GetDialListResp.prototype.addDialinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.DialInfoBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetDialListResp} returns this
 */
proto.xcommon.GetDialListResp.prototype.clearDialinfosList = function() {
  return this.setDialinfosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialInfoBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialInfoBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialInfoBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialInfoBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    dialinfo: (f = msg.getDialinfo()) && proto.xcommon.DialInfo.toObject(includeInstance, f),
    staffrole: jspb.Message.getFieldWithDefault(msg, 2, ""),
    majorleaderrole: jspb.Message.getFieldWithDefault(msg, 3, ""),
    minorleaderrole: jspb.Message.getFieldWithDefault(msg, 4, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 5, ""),
    itemname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    callmethod: jspb.Message.getFieldWithDefault(msg, 7, ""),
    hangupdirection: jspb.Message.getFieldWithDefault(msg, 8, ""),
    hangupcause: jspb.Message.getFieldWithDefault(msg, 9, ""),
    calldirection: jspb.Message.getFieldWithDefault(msg, 10, ""),
    dialway: jspb.Message.getFieldWithDefault(msg, 11, ""),
    createaudiocase: jspb.Message.getFieldWithDefault(msg, 12, 0),
    qiticketid: jspb.Message.getFieldWithDefault(msg, 13, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialInfoBackend}
 */
proto.xcommon.DialInfoBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialInfoBackend;
  return proto.xcommon.DialInfoBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialInfoBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialInfoBackend}
 */
proto.xcommon.DialInfoBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.DialInfo;
      reader.readMessage(value,proto.xcommon.DialInfo.deserializeBinaryFromReader);
      msg.setDialinfo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStaffrole(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMajorleaderrole(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinorleaderrole(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplier(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallmethod(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupdirection(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupcause(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalldirection(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDialway(value);
      break;
    case 12:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setCreateaudiocase(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setQiticketid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialInfoBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialInfoBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialInfoBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialInfoBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDialinfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.DialInfo.serializeBinaryToWriter
    );
  }
  f = message.getStaffrole();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMajorleaderrole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMinorleaderrole();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSupplier();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getItemname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCallmethod();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getHangupdirection();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHangupcause();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCalldirection();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDialway();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreateaudiocase();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getQiticketid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      13,
      f
    );
  }
};


/**
 * optional DialInfo DialInfo = 1;
 * @return {?proto.xcommon.DialInfo}
 */
proto.xcommon.DialInfoBackend.prototype.getDialinfo = function() {
  return /** @type{?proto.xcommon.DialInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.DialInfo, 1));
};


/**
 * @param {?proto.xcommon.DialInfo|undefined} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
*/
proto.xcommon.DialInfoBackend.prototype.setDialinfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.clearDialinfo = function() {
  return this.setDialinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialInfoBackend.prototype.hasDialinfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string StaffRole = 2;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getStaffrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setStaffrole = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string MajorLeaderRole = 3;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getMajorleaderrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setMajorleaderrole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string MinorLeaderRole = 4;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getMinorleaderrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setMinorleaderrole = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Supplier = 5;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getSupplier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string ItemName = 6;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getItemname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setItemname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string CallMethod = 7;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getCallmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setCallmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string HangupDirection = 8;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getHangupdirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setHangupdirection = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string HangupCause = 9;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getHangupcause = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setHangupcause = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CallDirection = 10;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getCalldirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setCalldirection = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string DialWay = 11;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getDialway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setDialway = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional Bool CreateAudioCase = 12;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.DialInfoBackend.prototype.getCreateaudiocase = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setCreateaudiocase = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional int64 QITicketId = 13;
 * @return {string}
 */
proto.xcommon.DialInfoBackend.prototype.getQiticketid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialInfoBackend} returns this
 */
proto.xcommon.DialInfoBackend.prototype.setQiticketid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MediaReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MediaReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MediaReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    voiprecordid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MediaReq}
 */
proto.xcommon.MediaReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MediaReq;
  return proto.xcommon.MediaReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MediaReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MediaReq}
 */
proto.xcommon.MediaReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setVoiprecordid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MediaReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MediaReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MediaReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getVoiprecordid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.MediaReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.MediaReq} returns this
*/
proto.xcommon.MediaReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.MediaReq} returns this
 */
proto.xcommon.MediaReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.MediaReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 VOIPRecordID = 2;
 * @return {string}
 */
proto.xcommon.MediaReq.prototype.getVoiprecordid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.MediaReq} returns this
 */
proto.xcommon.MediaReq.prototype.setVoiprecordid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MediaResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MediaResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MediaResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    mediaheader: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mediabody: msg.getMediabody_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MediaResp}
 */
proto.xcommon.MediaResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MediaResp;
  return proto.xcommon.MediaResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MediaResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MediaResp}
 */
proto.xcommon.MediaResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMediaheader(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMediabody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MediaResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MediaResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MediaResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getMediaheader();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMediabody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.MediaResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.MediaResp} returns this
*/
proto.xcommon.MediaResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.MediaResp} returns this
 */
proto.xcommon.MediaResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.MediaResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string MediaHeader = 2;
 * @return {string}
 */
proto.xcommon.MediaResp.prototype.getMediaheader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.MediaResp} returns this
 */
proto.xcommon.MediaResp.prototype.setMediaheader = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes MediaBody = 3;
 * @return {!(string|Uint8Array)}
 */
proto.xcommon.MediaResp.prototype.getMediabody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes MediaBody = 3;
 * This is a type-conversion wrapper around `getMediabody()`
 * @return {string}
 */
proto.xcommon.MediaResp.prototype.getMediabody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMediabody()));
};


/**
 * optional bytes MediaBody = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMediabody()`
 * @return {!Uint8Array}
 */
proto.xcommon.MediaResp.prototype.getMediabody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMediabody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.xcommon.MediaResp} returns this
 */
proto.xcommon.MediaResp.prototype.setMediabody = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MediaV2Req.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MediaV2Req.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MediaV2Req} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaV2Req.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    voiprecordid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MediaV2Req}
 */
proto.xcommon.MediaV2Req.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MediaV2Req;
  return proto.xcommon.MediaV2Req.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MediaV2Req} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MediaV2Req}
 */
proto.xcommon.MediaV2Req.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setVoiprecordid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MediaV2Req.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MediaV2Req.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MediaV2Req} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaV2Req.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getVoiprecordid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.MediaV2Req.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.MediaV2Req} returns this
*/
proto.xcommon.MediaV2Req.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.MediaV2Req} returns this
 */
proto.xcommon.MediaV2Req.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.MediaV2Req.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 VOIPRecordID = 2;
 * @return {string}
 */
proto.xcommon.MediaV2Req.prototype.getVoiprecordid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.MediaV2Req} returns this
 */
proto.xcommon.MediaV2Req.prototype.setVoiprecordid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MediaV2Resp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MediaV2Resp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MediaV2Resp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaV2Resp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    mediaheader: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mediabody: msg.getMediabody_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MediaV2Resp}
 */
proto.xcommon.MediaV2Resp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MediaV2Resp;
  return proto.xcommon.MediaV2Resp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MediaV2Resp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MediaV2Resp}
 */
proto.xcommon.MediaV2Resp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMediaheader(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMediabody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MediaV2Resp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MediaV2Resp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MediaV2Resp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaV2Resp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getMediaheader();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMediabody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.MediaV2Resp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.MediaV2Resp} returns this
*/
proto.xcommon.MediaV2Resp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.MediaV2Resp} returns this
 */
proto.xcommon.MediaV2Resp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.MediaV2Resp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string MediaHeader = 2;
 * @return {string}
 */
proto.xcommon.MediaV2Resp.prototype.getMediaheader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.MediaV2Resp} returns this
 */
proto.xcommon.MediaV2Resp.prototype.setMediaheader = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes MediaBody = 3;
 * @return {!(string|Uint8Array)}
 */
proto.xcommon.MediaV2Resp.prototype.getMediabody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes MediaBody = 3;
 * This is a type-conversion wrapper around `getMediabody()`
 * @return {string}
 */
proto.xcommon.MediaV2Resp.prototype.getMediabody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMediabody()));
};


/**
 * optional bytes MediaBody = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMediabody()`
 * @return {!Uint8Array}
 */
proto.xcommon.MediaV2Resp.prototype.getMediabody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMediabody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.xcommon.MediaV2Resp} returns this
 */
proto.xcommon.MediaV2Resp.prototype.setMediabody = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MediaObjKeyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MediaObjKeyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MediaObjKeyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaObjKeyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    voiprecordid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MediaObjKeyReq}
 */
proto.xcommon.MediaObjKeyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MediaObjKeyReq;
  return proto.xcommon.MediaObjKeyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MediaObjKeyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MediaObjKeyReq}
 */
proto.xcommon.MediaObjKeyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setVoiprecordid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MediaObjKeyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MediaObjKeyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MediaObjKeyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaObjKeyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getVoiprecordid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.MediaObjKeyReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.MediaObjKeyReq} returns this
*/
proto.xcommon.MediaObjKeyReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.MediaObjKeyReq} returns this
 */
proto.xcommon.MediaObjKeyReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.MediaObjKeyReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 VOIPRecordID = 2;
 * @return {string}
 */
proto.xcommon.MediaObjKeyReq.prototype.getVoiprecordid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.MediaObjKeyReq} returns this
 */
proto.xcommon.MediaObjKeyReq.prototype.setVoiprecordid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MediaObjKeyResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MediaObjKeyResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MediaObjKeyResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaObjKeyResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    objkey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    iscanredownload: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    origindownloadurl: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MediaObjKeyResp}
 */
proto.xcommon.MediaObjKeyResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MediaObjKeyResp;
  return proto.xcommon.MediaObjKeyResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MediaObjKeyResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MediaObjKeyResp}
 */
proto.xcommon.MediaObjKeyResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjkey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscanredownload(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigindownloadurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MediaObjKeyResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MediaObjKeyResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MediaObjKeyResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MediaObjKeyResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getObjkey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIscanredownload();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOrigindownloadurl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.MediaObjKeyResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.MediaObjKeyResp} returns this
*/
proto.xcommon.MediaObjKeyResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.MediaObjKeyResp} returns this
 */
proto.xcommon.MediaObjKeyResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.MediaObjKeyResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ObjKey = 2;
 * @return {string}
 */
proto.xcommon.MediaObjKeyResp.prototype.getObjkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.MediaObjKeyResp} returns this
 */
proto.xcommon.MediaObjKeyResp.prototype.setObjkey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool IsCanReDownload = 3;
 * @return {boolean}
 */
proto.xcommon.MediaObjKeyResp.prototype.getIscanredownload = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.MediaObjKeyResp} returns this
 */
proto.xcommon.MediaObjKeyResp.prototype.setIscanredownload = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string OriginDownloadURL = 4;
 * @return {string}
 */
proto.xcommon.MediaObjKeyResp.prototype.getOrigindownloadurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.MediaObjKeyResp} returns this
 */
proto.xcommon.MediaObjKeyResp.prototype.setOrigindownloadurl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.DialStatsReq.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    date: jspb.Message.getFieldWithDefault(msg, 3, ""),
    user: jspb.Message.getFieldWithDefault(msg, 4, ""),
    roleids: jspb.Message.getFieldWithDefault(msg, 5, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    extnumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 8, 0),
    dimensionList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    userid: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialStatsReq}
 */
proto.xcommon.DialStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialStatsReq;
  return proto.xcommon.DialStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialStatsReq}
 */
proto.xcommon.DialStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUser(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoleids(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtnumber(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupplier(value);
      break;
    case 9:
      var values = /** @type {!Array<!proto.xcommon.Dimension>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDimension(values[i]);
      }
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUser();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRoleids();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExtnumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getDimensionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      9,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DialStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.DialStatsReq} returns this
*/
proto.xcommon.DialStatsReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.DialStatsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.DialStatsReq} returns this
*/
proto.xcommon.DialStatsReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialStatsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Date = 3;
 * @return {string}
 */
proto.xcommon.DialStatsReq.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string User = 4;
 * @return {string}
 */
proto.xcommon.DialStatsReq.prototype.getUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.setUser = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string RoleIDs = 5;
 * @return {string}
 */
proto.xcommon.DialStatsReq.prototype.getRoleids = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.setRoleids = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 ItemID = 6;
 * @return {number}
 */
proto.xcommon.DialStatsReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string ExtNumber = 7;
 * @return {string}
 */
proto.xcommon.DialStatsReq.prototype.getExtnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 Supplier = 8;
 * @return {number}
 */
proto.xcommon.DialStatsReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated Dimension Dimension = 9;
 * @return {!Array<!proto.xcommon.Dimension>}
 */
proto.xcommon.DialStatsReq.prototype.getDimensionList = function() {
  return /** @type {!Array<!proto.xcommon.Dimension>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<!proto.xcommon.Dimension>} value
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.setDimensionList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {!proto.xcommon.Dimension} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.addDimension = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.clearDimensionList = function() {
  return this.setDimensionList([]);
};


/**
 * optional int64 UserID = 10;
 * @return {number}
 */
proto.xcommon.DialStatsReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsReq} returns this
 */
proto.xcommon.DialStatsReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.DialStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    dialstatsList: jspb.Message.toObjectList(msg.getDialstatsList(),
    proto.xcommon.DialStatsBackend.toObject, includeInstance),
    totalstats: (f = msg.getTotalstats()) && proto.xcommon.DialStatsBackend.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialStatsResp}
 */
proto.xcommon.DialStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialStatsResp;
  return proto.xcommon.DialStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialStatsResp}
 */
proto.xcommon.DialStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.DialStatsBackend;
      reader.readMessage(value,proto.xcommon.DialStatsBackend.deserializeBinaryFromReader);
      msg.addDialstats(value);
      break;
    case 4:
      var value = new proto.xcommon.DialStatsBackend;
      reader.readMessage(value,proto.xcommon.DialStatsBackend.deserializeBinaryFromReader);
      msg.setTotalstats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getDialstatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.DialStatsBackend.serializeBinaryToWriter
    );
  }
  f = message.getTotalstats();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.DialStatsBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DialStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.DialStatsResp} returns this
*/
proto.xcommon.DialStatsResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialStatsResp} returns this
 */
proto.xcommon.DialStatsResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.DialStatsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.DialStatsResp} returns this
*/
proto.xcommon.DialStatsResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialStatsResp} returns this
 */
proto.xcommon.DialStatsResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialStatsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated DialStatsBackend DialStats = 3;
 * @return {!Array<!proto.xcommon.DialStatsBackend>}
 */
proto.xcommon.DialStatsResp.prototype.getDialstatsList = function() {
  return /** @type{!Array<!proto.xcommon.DialStatsBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DialStatsBackend, 3));
};


/**
 * @param {!Array<!proto.xcommon.DialStatsBackend>} value
 * @return {!proto.xcommon.DialStatsResp} returns this
*/
proto.xcommon.DialStatsResp.prototype.setDialstatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.DialStatsBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DialStatsBackend}
 */
proto.xcommon.DialStatsResp.prototype.addDialstats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.DialStatsBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.DialStatsResp} returns this
 */
proto.xcommon.DialStatsResp.prototype.clearDialstatsList = function() {
  return this.setDialstatsList([]);
};


/**
 * optional DialStatsBackend TotalStats = 4;
 * @return {?proto.xcommon.DialStatsBackend}
 */
proto.xcommon.DialStatsResp.prototype.getTotalstats = function() {
  return /** @type{?proto.xcommon.DialStatsBackend} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.DialStatsBackend, 4));
};


/**
 * @param {?proto.xcommon.DialStatsBackend|undefined} value
 * @return {!proto.xcommon.DialStatsResp} returns this
*/
proto.xcommon.DialStatsResp.prototype.setTotalstats = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DialStatsResp} returns this
 */
proto.xcommon.DialStatsResp.prototype.clearTotalstats = function() {
  return this.setTotalstats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialStatsResp.prototype.hasTotalstats = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialStatsBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialStatsBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialStatsBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialStatsBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 2, ""),
    extnumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    user: jspb.Message.getFieldWithDefault(msg, 4, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    staffrole: jspb.Message.getFieldWithDefault(msg, 6, ""),
    itemname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    majorleaderrole: jspb.Message.getFieldWithDefault(msg, 8, ""),
    minorleaderrole: jspb.Message.getFieldWithDefault(msg, 9, ""),
    dialnum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    answernum: jspb.Message.getFieldWithDefault(msg, 11, 0),
    callduration: jspb.Message.getFieldWithDefault(msg, 12, 0),
    avgdialnum: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    avganswernum: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    callmedian: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    answerrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    validanswernum: jspb.Message.getFieldWithDefault(msg, 17, 0),
    orderdialnum: jspb.Message.getFieldWithDefault(msg, 18, 0),
    orderanswernum: jspb.Message.getFieldWithDefault(msg, 19, 0),
    ordervalidanswernum: jspb.Message.getFieldWithDefault(msg, 20, 0),
    orderanswerrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
    validanswerrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
    ordervalidanswerrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
    voicemailnum: jspb.Message.getFieldWithDefault(msg, 24, 0),
    userrejectnum: jspb.Message.getFieldWithDefault(msg, 25, 0),
    autorejectnum: jspb.Message.getFieldWithDefault(msg, 26, 0),
    ticketnum: jspb.Message.getFieldWithDefault(msg, 27, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialStatsBackend}
 */
proto.xcommon.DialStatsBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialStatsBackend;
  return proto.xcommon.DialStatsBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialStatsBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialStatsBackend}
 */
proto.xcommon.DialStatsBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplier(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtnumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUser(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStaffrole(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMajorleaderrole(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinorleaderrole(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDialnum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswernum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallduration(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAvgdialnum(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAvganswernum(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCallmedian(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAnswerrate(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValidanswernum(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderdialnum(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderanswernum(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrdervalidanswernum(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOrderanswerrate(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValidanswerrate(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOrdervalidanswerrate(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVoicemailnum(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserrejectnum(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAutorejectnum(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketnum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialStatsBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialStatsBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialStatsBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialStatsBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSupplier();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExtnumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUser();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStaffrole();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getItemname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMajorleaderrole();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMinorleaderrole();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDialnum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAnswernum();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getCallduration();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getAvgdialnum();
  if (f !== 0.0) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = message.getAvganswernum();
  if (f !== 0.0) {
    writer.writeFloat(
      14,
      f
    );
  }
  f = message.getCallmedian();
  if (f !== 0.0) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = message.getAnswerrate();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getValidanswernum();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getOrderdialnum();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getOrderanswernum();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getOrdervalidanswernum();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getOrderanswerrate();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getValidanswerrate();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getOrdervalidanswerrate();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getVoicemailnum();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getUserrejectnum();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getAutorejectnum();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getTicketnum();
  if (f !== 0) {
    writer.writeInt64(
      27,
      f
    );
  }
};


/**
 * optional string Date = 1;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Supplier = 2;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getSupplier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ExtNumber = 3;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getExtnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setExtnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string User = 4;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setUser = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UserID = 5;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string StaffRole = 6;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getStaffrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setStaffrole = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string ItemName = 7;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getItemname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setItemname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string MajorLeaderRole = 8;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getMajorleaderrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setMajorleaderrole = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string MinorLeaderRole = 9;
 * @return {string}
 */
proto.xcommon.DialStatsBackend.prototype.getMinorleaderrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setMinorleaderrole = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 DialNum = 10;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getDialnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setDialnum = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 AnswerNum = 11;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getAnswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setAnswernum = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 CallDuration = 12;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getCallduration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setCallduration = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional float AvgDialNum = 13;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getAvgdialnum = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setAvgdialnum = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional float AvgAnswerNum = 14;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getAvganswernum = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setAvganswernum = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional float CallMedian = 15;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getCallmedian = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setCallmedian = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double AnswerRate = 16;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getAnswerrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setAnswerrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional int64 ValidAnswerNum = 17;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getValidanswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setValidanswernum = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 OrderDialNum = 18;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getOrderdialnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setOrderdialnum = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 OrderAnswerNum = 19;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getOrderanswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setOrderanswernum = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 OrderValidAnswerNum = 20;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getOrdervalidanswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setOrdervalidanswernum = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional double OrderAnswerRate = 21;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getOrderanswerrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setOrderanswerrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional double ValidAnswerRate = 22;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getValidanswerrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setValidanswerrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional double OrderValidAnswerRate = 23;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getOrdervalidanswerrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setOrdervalidanswerrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional int64 VoiceMailNum = 24;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getVoicemailnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setVoicemailnum = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 UserRejectNum = 25;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getUserrejectnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setUserrejectnum = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 AutoRejectNum = 26;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getAutorejectnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setAutorejectnum = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int64 TicketNum = 27;
 * @return {number}
 */
proto.xcommon.DialStatsBackend.prototype.getTicketnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DialStatsBackend} returns this
 */
proto.xcommon.DialStatsBackend.prototype.setTicketnum = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CallRecordReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CallRecordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CallRecordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CallRecordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallRecordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dialidsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CallRecordReq}
 */
proto.xcommon.CallRecordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CallRecordReq;
  return proto.xcommon.CallRecordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CallRecordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CallRecordReq}
 */
proto.xcommon.CallRecordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDialids(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CallRecordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CallRecordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CallRecordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallRecordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDialidsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CallRecordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.CallRecordReq} returns this
*/
proto.xcommon.CallRecordReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CallRecordReq} returns this
 */
proto.xcommon.CallRecordReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CallRecordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Date = 2;
 * @return {string}
 */
proto.xcommon.CallRecordReq.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CallRecordReq} returns this
 */
proto.xcommon.CallRecordReq.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated int64 DialIds = 3;
 * @return {!Array<number>}
 */
proto.xcommon.CallRecordReq.prototype.getDialidsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.xcommon.CallRecordReq} returns this
 */
proto.xcommon.CallRecordReq.prototype.setDialidsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CallRecordReq} returns this
 */
proto.xcommon.CallRecordReq.prototype.addDialids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.CallRecordReq} returns this
 */
proto.xcommon.CallRecordReq.prototype.clearDialidsList = function() {
  return this.setDialidsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CallRecordResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CallRecordResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CallRecordResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CallRecordResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallRecordResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.DialInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CallRecordResp}
 */
proto.xcommon.CallRecordResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CallRecordResp;
  return proto.xcommon.CallRecordResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CallRecordResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CallRecordResp}
 */
proto.xcommon.CallRecordResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.DialInfo;
      reader.readMessage(value,proto.xcommon.DialInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CallRecordResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CallRecordResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CallRecordResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallRecordResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.DialInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CallRecordResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.CallRecordResp} returns this
*/
proto.xcommon.CallRecordResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CallRecordResp} returns this
 */
proto.xcommon.CallRecordResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CallRecordResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DialInfo List = 2;
 * @return {!Array<!proto.xcommon.DialInfo>}
 */
proto.xcommon.CallRecordResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.DialInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DialInfo, 2));
};


/**
 * @param {!Array<!proto.xcommon.DialInfo>} value
 * @return {!proto.xcommon.CallRecordResp} returns this
*/
proto.xcommon.CallRecordResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.DialInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DialInfo}
 */
proto.xcommon.CallRecordResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.DialInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.CallRecordResp} returns this
 */
proto.xcommon.CallRecordResp.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CallTextReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CallTextReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CallTextReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallTextReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CallTextReq}
 */
proto.xcommon.CallTextReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CallTextReq;
  return proto.xcommon.CallTextReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CallTextReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CallTextReq}
 */
proto.xcommon.CallTextReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CallTextReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CallTextReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CallTextReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallTextReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CallTextReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.CallTextReq} returns this
*/
proto.xcommon.CallTextReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CallTextReq} returns this
 */
proto.xcommon.CallTextReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CallTextReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {string}
 */
proto.xcommon.CallTextReq.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CallTextReq} returns this
 */
proto.xcommon.CallTextReq.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CallTextResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CallTextResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CallTextResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CallTextResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallTextResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.xcommon.AudioText.toObject, includeInstance),
    audiomarktextMap: (f = msg.getAudiomarktextMap()) ? f.toObject(includeInstance, proto.xcommon.AudioMarkTextList.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CallTextResp}
 */
proto.xcommon.CallTextResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CallTextResp;
  return proto.xcommon.CallTextResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CallTextResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CallTextResp}
 */
proto.xcommon.CallTextResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AudioText;
      reader.readMessage(value,proto.xcommon.AudioText.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 3:
      var value = msg.getAudiomarktextMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.AudioMarkTextList.deserializeBinaryFromReader, 0, new proto.xcommon.AudioMarkTextList());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CallTextResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CallTextResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CallTextResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallTextResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AudioText.serializeBinaryToWriter
    );
  }
  f = message.getAudiomarktextMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.AudioMarkTextList.serializeBinaryToWriter);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CallTextResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.CallTextResp} returns this
*/
proto.xcommon.CallTextResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CallTextResp} returns this
 */
proto.xcommon.CallTextResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CallTextResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AudioText Data = 2;
 * @return {!Array<!proto.xcommon.AudioText>}
 */
proto.xcommon.CallTextResp.prototype.getDataList = function() {
  return /** @type{!Array<!proto.xcommon.AudioText>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AudioText, 2));
};


/**
 * @param {!Array<!proto.xcommon.AudioText>} value
 * @return {!proto.xcommon.CallTextResp} returns this
*/
proto.xcommon.CallTextResp.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AudioText=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioText}
 */
proto.xcommon.CallTextResp.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AudioText, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.CallTextResp} returns this
 */
proto.xcommon.CallTextResp.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * map<int32, AudioMarkTextList> AudioMarkText = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.AudioMarkTextList>}
 */
proto.xcommon.CallTextResp.prototype.getAudiomarktextMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.AudioMarkTextList>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.xcommon.AudioMarkTextList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.CallTextResp} returns this
 */
proto.xcommon.CallTextResp.prototype.clearAudiomarktextMap = function() {
  this.getAudiomarktextMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AudioText.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AudioText.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AudioText.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AudioText} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioText.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sentence: jspb.Message.getFieldWithDefault(msg, 2, 0),
    content: jspb.Message.getFieldWithDefault(msg, 3, ""),
    confidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    timestart: jspb.Message.getFieldWithDefault(msg, 7, 0),
    timeend: jspb.Message.getFieldWithDefault(msg, 8, 0),
    timelong: jspb.Message.getFieldWithDefault(msg, 9, 0),
    channeltag: jspb.Message.getFieldWithDefault(msg, 10, 0),
    wordsnums: jspb.Message.getFieldWithDefault(msg, 11, 0),
    speakertag: jspb.Message.getFieldWithDefault(msg, 13, 0),
    marktextList: jspb.Message.toObjectList(msg.getMarktextList(),
    proto.xcommon.AudioMarkText.toObject, includeInstance),
    labels: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AudioText}
 */
proto.xcommon.AudioText.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AudioText;
  return proto.xcommon.AudioText.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AudioText} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AudioText}
 */
proto.xcommon.AudioText.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSentence(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setConfidence(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestart(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeend(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimelong(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChanneltag(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWordsnums(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSpeakertag(value);
      break;
    case 14:
      var value = new proto.xcommon.AudioMarkText;
      reader.readMessage(value,proto.xcommon.AudioMarkText.deserializeBinaryFromReader);
      msg.addMarktext(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AudioText.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AudioText.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AudioText} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioText.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSentence();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getTimestart();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTimeend();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getTimelong();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getChanneltag();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getWordsnums();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getSpeakertag();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getMarktextList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.xcommon.AudioMarkText.serializeBinaryToWriter
    );
  }
  f = message.getLabels();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Sentence = 2;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getSentence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setSentence = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Content = 3;
 * @return {string}
 */
proto.xcommon.AudioText.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional float Confidence = 6;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 TimeStart = 7;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getTimestart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setTimestart = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 TimeEnd = 8;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getTimeend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setTimeend = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 TimeLong = 9;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getTimelong = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setTimelong = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 ChannelTag = 10;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getChanneltag = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setChanneltag = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 WordsNums = 11;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getWordsnums = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setWordsnums = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 SpeakerTag = 13;
 * @return {number}
 */
proto.xcommon.AudioText.prototype.getSpeakertag = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setSpeakertag = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * repeated AudioMarkText MarkText = 14;
 * @return {!Array<!proto.xcommon.AudioMarkText>}
 */
proto.xcommon.AudioText.prototype.getMarktextList = function() {
  return /** @type{!Array<!proto.xcommon.AudioMarkText>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AudioMarkText, 14));
};


/**
 * @param {!Array<!proto.xcommon.AudioMarkText>} value
 * @return {!proto.xcommon.AudioText} returns this
*/
proto.xcommon.AudioText.prototype.setMarktextList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.xcommon.AudioMarkText=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioMarkText}
 */
proto.xcommon.AudioText.prototype.addMarktext = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.xcommon.AudioMarkText, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.clearMarktextList = function() {
  return this.setMarktextList([]);
};


/**
 * optional string Labels = 15;
 * @return {string}
 */
proto.xcommon.AudioText.prototype.getLabels = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.AudioText} returns this
 */
proto.xcommon.AudioText.prototype.setLabels = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AudioMarkTextList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AudioMarkTextList.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AudioMarkTextList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AudioMarkTextList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioMarkTextList.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AudioMarkText.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AudioMarkTextList}
 */
proto.xcommon.AudioMarkTextList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AudioMarkTextList;
  return proto.xcommon.AudioMarkTextList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AudioMarkTextList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AudioMarkTextList}
 */
proto.xcommon.AudioMarkTextList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.AudioMarkText;
      reader.readMessage(value,proto.xcommon.AudioMarkText.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AudioMarkTextList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AudioMarkTextList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AudioMarkTextList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioMarkTextList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.xcommon.AudioMarkText.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AudioMarkText List = 1;
 * @return {!Array<!proto.xcommon.AudioMarkText>}
 */
proto.xcommon.AudioMarkTextList.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AudioMarkText>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AudioMarkText, 1));
};


/**
 * @param {!Array<!proto.xcommon.AudioMarkText>} value
 * @return {!proto.xcommon.AudioMarkTextList} returns this
*/
proto.xcommon.AudioMarkTextList.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.AudioMarkText=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioMarkText}
 */
proto.xcommon.AudioMarkTextList.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.AudioMarkText, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.AudioMarkTextList} returns this
 */
proto.xcommon.AudioMarkTextList.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AudioMarkText.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AudioMarkText.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AudioMarkText} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioMarkText.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contentmark: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentmodify: jspb.Message.getFieldWithDefault(msg, 3, ""),
    label: jspb.Message.getFieldWithDefault(msg, 4, 0),
    speechid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    audioid: jspb.Message.getFieldWithDefault(msg, 6, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AudioMarkText}
 */
proto.xcommon.AudioMarkText.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AudioMarkText;
  return proto.xcommon.AudioMarkText.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AudioMarkText} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AudioMarkText}
 */
proto.xcommon.AudioMarkText.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentmark(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentmodify(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLabel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSpeechid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAudioid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AudioMarkText.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AudioMarkText.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AudioMarkText} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioMarkText.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getContentmark();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentmodify();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLabel();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSpeechid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAudioid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {number}
 */
proto.xcommon.AudioMarkText.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioMarkText} returns this
 */
proto.xcommon.AudioMarkText.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ContentMark = 2;
 * @return {string}
 */
proto.xcommon.AudioMarkText.prototype.getContentmark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.AudioMarkText} returns this
 */
proto.xcommon.AudioMarkText.prototype.setContentmark = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ContentModify = 3;
 * @return {string}
 */
proto.xcommon.AudioMarkText.prototype.getContentmodify = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.AudioMarkText} returns this
 */
proto.xcommon.AudioMarkText.prototype.setContentmodify = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 Label = 4;
 * @return {number}
 */
proto.xcommon.AudioMarkText.prototype.getLabel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioMarkText} returns this
 */
proto.xcommon.AudioMarkText.prototype.setLabel = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 SpeechId = 5;
 * @return {number}
 */
proto.xcommon.AudioMarkText.prototype.getSpeechid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.AudioMarkText} returns this
 */
proto.xcommon.AudioMarkText.prototype.setSpeechid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AudioId = 6;
 * @return {string}
 */
proto.xcommon.AudioMarkText.prototype.getAudioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.AudioMarkText} returns this
 */
proto.xcommon.AudioMarkText.prototype.setAudioid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SaveCallTextReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveCallTextReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveCallTextReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveCallTextReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveCallTextReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.xcommon.AudioMarkText.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveCallTextReq}
 */
proto.xcommon.SaveCallTextReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveCallTextReq;
  return proto.xcommon.SaveCallTextReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveCallTextReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveCallTextReq}
 */
proto.xcommon.SaveCallTextReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.AudioMarkText;
      reader.readMessage(value,proto.xcommon.AudioMarkText.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveCallTextReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveCallTextReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveCallTextReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveCallTextReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AudioMarkText.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveCallTextReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveCallTextReq} returns this
*/
proto.xcommon.SaveCallTextReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveCallTextReq} returns this
 */
proto.xcommon.SaveCallTextReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveCallTextReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AudioMarkText Data = 2;
 * @return {!Array<!proto.xcommon.AudioMarkText>}
 */
proto.xcommon.SaveCallTextReq.prototype.getDataList = function() {
  return /** @type{!Array<!proto.xcommon.AudioMarkText>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AudioMarkText, 2));
};


/**
 * @param {!Array<!proto.xcommon.AudioMarkText>} value
 * @return {!proto.xcommon.SaveCallTextReq} returns this
*/
proto.xcommon.SaveCallTextReq.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AudioMarkText=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioMarkText}
 */
proto.xcommon.SaveCallTextReq.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AudioMarkText, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.SaveCallTextReq} returns this
 */
proto.xcommon.SaveCallTextReq.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveCallTextResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveCallTextResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveCallTextResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveCallTextResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveCallTextResp}
 */
proto.xcommon.SaveCallTextResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveCallTextResp;
  return proto.xcommon.SaveCallTextResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveCallTextResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveCallTextResp}
 */
proto.xcommon.SaveCallTextResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveCallTextResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveCallTextResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveCallTextResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveCallTextResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveCallTextResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveCallTextResp} returns this
*/
proto.xcommon.SaveCallTextResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveCallTextResp} returns this
 */
proto.xcommon.SaveCallTextResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveCallTextResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchAudioQualityReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchAudioQualityReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchAudioQualityReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchAudioQualityReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchAudioQualityReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    audioidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchAudioQualityReq}
 */
proto.xcommon.BatchAudioQualityReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchAudioQualityReq;
  return proto.xcommon.BatchAudioQualityReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchAudioQualityReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchAudioQualityReq}
 */
proto.xcommon.BatchAudioQualityReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAudioids(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchAudioQualityReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchAudioQualityReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchAudioQualityReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchAudioQualityReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAudioidsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.BatchAudioQualityReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.BatchAudioQualityReq} returns this
*/
proto.xcommon.BatchAudioQualityReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.BatchAudioQualityReq} returns this
 */
proto.xcommon.BatchAudioQualityReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchAudioQualityReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 AudioIds = 2;
 * @return {!Array<number>}
 */
proto.xcommon.BatchAudioQualityReq.prototype.getAudioidsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.xcommon.BatchAudioQualityReq} returns this
 */
proto.xcommon.BatchAudioQualityReq.prototype.setAudioidsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.BatchAudioQualityReq} returns this
 */
proto.xcommon.BatchAudioQualityReq.prototype.addAudioids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.BatchAudioQualityReq} returns this
 */
proto.xcommon.BatchAudioQualityReq.prototype.clearAudioidsList = function() {
  return this.setAudioidsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallRecordListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallRecordListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallRecordListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecordListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    orderids: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallRecordListReq}
 */
proto.xcommon.RobotCallRecordListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallRecordListReq;
  return proto.xcommon.RobotCallRecordListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallRecordListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallRecordListReq}
 */
proto.xcommon.RobotCallRecordListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallRecordListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallRecordListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallRecordListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecordListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getOrderids();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.RobotCallRecordListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.RobotCallRecordListReq} returns this
*/
proto.xcommon.RobotCallRecordListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RobotCallRecordListReq} returns this
 */
proto.xcommon.RobotCallRecordListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallRecordListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.RobotCallRecordListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.RobotCallRecordListReq} returns this
*/
proto.xcommon.RobotCallRecordListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RobotCallRecordListReq} returns this
 */
proto.xcommon.RobotCallRecordListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallRecordListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.RobotCallRecordListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecordListReq} returns this
 */
proto.xcommon.RobotCallRecordListReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string OrderIds = 4;
 * @return {string}
 */
proto.xcommon.RobotCallRecordListReq.prototype.getOrderids = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecordListReq} returns this
 */
proto.xcommon.RobotCallRecordListReq.prototype.setOrderids = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.RobotCallRecordListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallRecordListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallRecordListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallRecordListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecordListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.RobotCallRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallRecordListResp}
 */
proto.xcommon.RobotCallRecordListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallRecordListResp;
  return proto.xcommon.RobotCallRecordListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallRecordListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallRecordListResp}
 */
proto.xcommon.RobotCallRecordListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.RobotCallRecord;
      reader.readMessage(value,proto.xcommon.RobotCallRecord.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallRecordListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallRecordListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallRecordListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecordListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.RobotCallRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.RobotCallRecordListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.RobotCallRecordListResp} returns this
*/
proto.xcommon.RobotCallRecordListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RobotCallRecordListResp} returns this
 */
proto.xcommon.RobotCallRecordListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallRecordListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.RobotCallRecordListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.RobotCallRecordListResp} returns this
*/
proto.xcommon.RobotCallRecordListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RobotCallRecordListResp} returns this
 */
proto.xcommon.RobotCallRecordListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallRecordListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated RobotCallRecord List = 3;
 * @return {!Array<!proto.xcommon.RobotCallRecord>}
 */
proto.xcommon.RobotCallRecordListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.RobotCallRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RobotCallRecord, 3));
};


/**
 * @param {!Array<!proto.xcommon.RobotCallRecord>} value
 * @return {!proto.xcommon.RobotCallRecordListResp} returns this
*/
proto.xcommon.RobotCallRecordListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.RobotCallRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RobotCallRecord}
 */
proto.xcommon.RobotCallRecordListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.RobotCallRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.RobotCallRecordListResp} returns this
 */
proto.xcommon.RobotCallRecordListResp.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallRecordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallRecordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallRecordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallRecordReq}
 */
proto.xcommon.RobotCallRecordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallRecordReq;
  return proto.xcommon.RobotCallRecordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallRecordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallRecordReq}
 */
proto.xcommon.RobotCallRecordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallRecordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallRecordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallRecordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.RobotCallRecordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.RobotCallRecordReq} returns this
*/
proto.xcommon.RobotCallRecordReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RobotCallRecordReq} returns this
 */
proto.xcommon.RobotCallRecordReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallRecordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.RobotCallRecordReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RobotCallRecordReq} returns this
 */
proto.xcommon.RobotCallRecordReq.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallRecordResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallRecordResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallRecordResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecordResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.RobotCallRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallRecordResp}
 */
proto.xcommon.RobotCallRecordResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallRecordResp;
  return proto.xcommon.RobotCallRecordResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallRecordResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallRecordResp}
 */
proto.xcommon.RobotCallRecordResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.RobotCallRecord;
      reader.readMessage(value,proto.xcommon.RobotCallRecord.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallRecordResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallRecordResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallRecordResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecordResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.RobotCallRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.RobotCallRecordResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.RobotCallRecordResp} returns this
*/
proto.xcommon.RobotCallRecordResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RobotCallRecordResp} returns this
 */
proto.xcommon.RobotCallRecordResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallRecordResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RobotCallRecord Data = 2;
 * @return {?proto.xcommon.RobotCallRecord}
 */
proto.xcommon.RobotCallRecordResp.prototype.getData = function() {
  return /** @type{?proto.xcommon.RobotCallRecord} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.RobotCallRecord, 2));
};


/**
 * @param {?proto.xcommon.RobotCallRecord|undefined} value
 * @return {!proto.xcommon.RobotCallRecordResp} returns this
*/
proto.xcommon.RobotCallRecordResp.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RobotCallRecordResp} returns this
 */
proto.xcommon.RobotCallRecordResp.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallRecordResp.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.RobotCallRecord.repeatedFields_ = [12,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    audioid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    calltime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    overduedays: jspb.Message.getFieldWithDefault(msg, 5, 0),
    suppliername: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isdial: jspb.Message.getFieldWithDefault(msg, 7, 0),
    unconnectreason: jspb.Message.getFieldWithDefault(msg, 8, ""),
    hangupcause: jspb.Message.getFieldWithDefault(msg, 9, ""),
    suggest: jspb.Message.getFieldWithDefault(msg, 10, ""),
    calltags: jspb.Message.getFieldWithDefault(msg, 11, ""),
    dialogdetailList: jspb.Message.toObjectList(msg.getDialogdetailList(),
    proto.xcommon.RobotCallDialog.toObject, includeInstance),
    ctime: jspb.Message.getFieldWithDefault(msg, 13, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    robotdialogList: jspb.Message.toObjectList(msg.getRobotdialogList(),
    xcommon_common_pb.RobotDialog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallRecord}
 */
proto.xcommon.RobotCallRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallRecord;
  return proto.xcommon.RobotCallRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallRecord}
 */
proto.xcommon.RobotCallRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAudioid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCalltime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOverduedays(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuppliername(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsdial(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnconnectreason(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupcause(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuggest(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalltags(value);
      break;
    case 12:
      var value = new proto.xcommon.RobotCallDialog;
      reader.readMessage(value,proto.xcommon.RobotCallDialog.deserializeBinaryFromReader);
      msg.addDialogdetail(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 15:
      var value = new xcommon_common_pb.RobotDialog;
      reader.readMessage(value,xcommon_common_pb.RobotDialog.deserializeBinaryFromReader);
      msg.addRobotdialog(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAudioid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCalltime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOverduedays();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSuppliername();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsdial();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getUnconnectreason();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHangupcause();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSuggest();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCalltags();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDialogdetailList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.xcommon.RobotCallDialog.serializeBinaryToWriter
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getRobotdialogList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      xcommon_common_pb.RobotDialog.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {number}
 */
proto.xcommon.RobotCallRecord.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 AudioId = 2;
 * @return {string}
 */
proto.xcommon.RobotCallRecord.prototype.getAudioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setAudioid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 OrderID = 3;
 * @return {string}
 */
proto.xcommon.RobotCallRecord.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 CallTime = 4;
 * @return {number}
 */
proto.xcommon.RobotCallRecord.prototype.getCalltime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setCalltime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OverdueDays = 5;
 * @return {number}
 */
proto.xcommon.RobotCallRecord.prototype.getOverduedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setOverduedays = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string SupplierName = 6;
 * @return {string}
 */
proto.xcommon.RobotCallRecord.prototype.getSuppliername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setSuppliername = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Bool IsDial = 7;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.RobotCallRecord.prototype.getIsdial = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setIsdial = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string UnconnectReason = 8;
 * @return {string}
 */
proto.xcommon.RobotCallRecord.prototype.getUnconnectreason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setUnconnectreason = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string HangupCause = 9;
 * @return {string}
 */
proto.xcommon.RobotCallRecord.prototype.getHangupcause = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setHangupcause = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Suggest = 10;
 * @return {string}
 */
proto.xcommon.RobotCallRecord.prototype.getSuggest = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setSuggest = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string CallTags = 11;
 * @return {string}
 */
proto.xcommon.RobotCallRecord.prototype.getCalltags = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setCalltags = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated RobotCallDialog DialogDetail = 12;
 * @return {!Array<!proto.xcommon.RobotCallDialog>}
 */
proto.xcommon.RobotCallRecord.prototype.getDialogdetailList = function() {
  return /** @type{!Array<!proto.xcommon.RobotCallDialog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RobotCallDialog, 12));
};


/**
 * @param {!Array<!proto.xcommon.RobotCallDialog>} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
*/
proto.xcommon.RobotCallRecord.prototype.setDialogdetailList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.xcommon.RobotCallDialog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RobotCallDialog}
 */
proto.xcommon.RobotCallRecord.prototype.addDialogdetail = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.xcommon.RobotCallDialog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.clearDialogdetailList = function() {
  return this.setDialogdetailList([]);
};


/**
 * optional int64 Ctime = 13;
 * @return {number}
 */
proto.xcommon.RobotCallRecord.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 Utime = 14;
 * @return {number}
 */
proto.xcommon.RobotCallRecord.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * repeated RobotDialog RobotDialog = 15;
 * @return {!Array<!proto.xcommon.RobotDialog>}
 */
proto.xcommon.RobotCallRecord.prototype.getRobotdialogList = function() {
  return /** @type{!Array<!proto.xcommon.RobotDialog>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_common_pb.RobotDialog, 15));
};


/**
 * @param {!Array<!proto.xcommon.RobotDialog>} value
 * @return {!proto.xcommon.RobotCallRecord} returns this
*/
proto.xcommon.RobotCallRecord.prototype.setRobotdialogList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.xcommon.RobotDialog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RobotDialog}
 */
proto.xcommon.RobotCallRecord.prototype.addRobotdialog = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.xcommon.RobotDialog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.RobotCallRecord} returns this
 */
proto.xcommon.RobotCallRecord.prototype.clearRobotdialogList = function() {
  return this.setRobotdialogList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallDialog.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallDialog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallDialog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallDialog.toObject = function(includeInstance, msg) {
  var f, obj = {
    role: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    intent: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallDialog}
 */
proto.xcommon.RobotCallDialog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallDialog;
  return proto.xcommon.RobotCallDialog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallDialog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallDialog}
 */
proto.xcommon.RobotCallDialog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallDialog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallDialog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallDialog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallDialog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIntent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Role = 1;
 * @return {string}
 */
proto.xcommon.RobotCallDialog.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallDialog} returns this
 */
proto.xcommon.RobotCallDialog.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Text = 2;
 * @return {string}
 */
proto.xcommon.RobotCallDialog.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallDialog} returns this
 */
proto.xcommon.RobotCallDialog.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Intent = 3;
 * @return {string}
 */
proto.xcommon.RobotCallDialog.prototype.getIntent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RobotCallDialog} returns this
 */
proto.xcommon.RobotCallDialog.prototype.setIntent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WhetherRobotCallListResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WhetherRobotCallListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WhetherRobotCallListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WhetherRobotCallListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WhetherRobotCallListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    orderidList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WhetherRobotCallListResp}
 */
proto.xcommon.WhetherRobotCallListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WhetherRobotCallListResp;
  return proto.xcommon.WhetherRobotCallListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WhetherRobotCallListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WhetherRobotCallListResp}
 */
proto.xcommon.WhetherRobotCallListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var values = /** @type {!Array<string>} */ (reader.isDelimited() ? reader.readPackedInt64String() : [reader.readInt64String()]);
      for (var i = 0; i < values.length; i++) {
        msg.addOrderid(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WhetherRobotCallListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WhetherRobotCallListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WhetherRobotCallListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WhetherRobotCallListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOrderidList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WhetherRobotCallListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.WhetherRobotCallListResp} returns this
*/
proto.xcommon.WhetherRobotCallListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.WhetherRobotCallListResp} returns this
 */
proto.xcommon.WhetherRobotCallListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WhetherRobotCallListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 OrderID = 2;
 * @return {!Array<string>}
 */
proto.xcommon.WhetherRobotCallListResp.prototype.getOrderidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.xcommon.WhetherRobotCallListResp} returns this
 */
proto.xcommon.WhetherRobotCallListResp.prototype.setOrderidList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WhetherRobotCallListResp} returns this
 */
proto.xcommon.WhetherRobotCallListResp.prototype.addOrderid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.WhetherRobotCallListResp} returns this
 */
proto.xcommon.WhetherRobotCallListResp.prototype.clearOrderidList = function() {
  return this.setOrderidList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTimeRangeRobotDialStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTimeRangeRobotDialStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    timestart: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timeend: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketorderidmapMap: (f = msg.getTicketorderidmapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusReq}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTimeRangeRobotDialStatusReq;
  return proto.xcommon.GetTimeRangeRobotDialStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTimeRangeRobotDialStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusReq}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestart(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeend(value);
      break;
    case 4:
      var value = msg.getTicketorderidmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readInt64, null, 0, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTimeRangeRobotDialStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTimeRangeRobotDialStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTimestart();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTimeend();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTicketorderidmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeInt64);
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusReq} returns this
*/
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusReq} returns this
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TimeStart = 2;
 * @return {number}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.getTimestart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusReq} returns this
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.setTimestart = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 TimeEnd = 3;
 * @return {number}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.getTimeend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusReq} returns this
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.setTimeend = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * map<int64, int64> TicketOrderIdMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.getTicketorderidmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusReq} returns this
 */
proto.xcommon.GetTimeRangeRobotDialStatusReq.prototype.clearTicketorderidmapMap = function() {
  this.getTicketorderidmapMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTimeRangeRobotDialStatusResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTimeRangeRobotDialStatusResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    ticketdialstatusMap: (f = msg.getTicketdialstatusMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusResp}
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTimeRangeRobotDialStatusResp;
  return proto.xcommon.GetTimeRangeRobotDialStatusResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTimeRangeRobotDialStatusResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusResp}
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getTicketdialstatusMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readInt64, null, 0, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTimeRangeRobotDialStatusResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTimeRangeRobotDialStatusResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTicketdialstatusMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeInt64);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusResp} returns this
*/
proto.xcommon.GetTimeRangeRobotDialStatusResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusResp} returns this
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int64, int64> TicketDialStatus = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.prototype.getTicketdialstatusMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetTimeRangeRobotDialStatusResp} returns this
 */
proto.xcommon.GetTimeRangeRobotDialStatusResp.prototype.clearTicketdialstatusMap = function() {
  this.getTicketdialstatusMap().clear();
  return this;
};


/**
 * @enum {number}
 */
proto.xcommon.Operate = {
  ERROP: 0,
  ADD: 1,
  UPDATE: 2,
  DEL: 3
};

/**
 * @enum {number}
 */
proto.xcommon.Dimension = {
  DATE: 0,
  SUPPLIER: 1,
  EXTNUMBER: 2,
  USER: 3,
  ROLE: 4,
  ITEM: 5
};

module.exports = proto.xcommon;
